import {
  Notifications as NotificationsIcon,
  Settings as SettingsIcon,
  Warning as WarningIcon,
} from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import SvgToIcon from "../../icons/SvgToIcon";
// SVG component for demo
const CustomSvg = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-9h10v2H7z" />
  </svg>
);

/**
 * Demo component for SvgToIcon
 * Shows different sizes, styles, and usage patterns
 */
const SvgToIconDemo = () => {
  const colors = useColors();
  return (
    <Box>
      <Grid container spacing={3}>
        {/* Basic usage */}
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="subtitle2" gutterBottom>
              Basic Usage
            </Typography>
            <SvgToIcon IconLogo={NotificationsIcon} />
          </Box>
        </Grid>

        {/* Custom size */}
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="subtitle2" gutterBottom>
              Custom Size
            </Typography>
            <SvgToIcon IconLogo={SettingsIcon} width="40px" height="40px" />
          </Box>
        </Grid>

        {/* Custom style */}
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="subtitle2" gutterBottom>
              Custom Styling
            </Typography>
            <SvgToIcon
              IconLogo={WarningIcon}
              style={{ color: "orange", opacity: 0.8 }}
            />
          </Box>
        </Grid>

        {/* Custom SVG component */}
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="subtitle2" gutterBottom>
              Custom SVG
            </Typography>
            <SvgToIcon IconLogo={CustomSvg} style={{ color: "#2196F3" }} />
          </Box>
        </Grid>

        {/* In a button */}
        <Grid item xs={12} md={4}>
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="subtitle2" gutterBottom>
              In a Container
            </Typography>
            <Box
              sx={{
                display: "inline-flex",
                backgroundColor: "#f5f5f5",
                padding: "8px",
                borderRadius: "4px",
              }}
            >
              <SvgToIcon
                IconLogo={NotificationsIcon}
                style={{ color: "primary.main" }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SvgToIconDemo;
